const STORAGE_KEY = "karnov.authorsportal.showBooks";

// An employee can preview how the portal looks without books (user decision 2026-10-06).
// The choice is stored per browser, never in the server profile. Default for an employee: ON.
export const getIncludeBooks = (): boolean => {
    try {
        return localStorage.getItem(STORAGE_KEY) !== "false";
    } catch {
        return true;
    }
};

export const setIncludeBooks = (value: boolean): void => {
    try {
        localStorage.setItem(STORAGE_KEY, value ? "true" : "false");
    } catch {
        // A full or blocked localStorage must not break the portal.
    }
};
